import { z } from 'zod';
import { createUpdateZodSchema } from '../types/DateUtils.types';

const MediaMetaSchema = z.object({
  title: z.string().optional(),
  alt: z.string().optional(),
  caption: z.string().optional(),
}).catchall(z.any());

export const MediaDtoSchema = z.object({
  id: z.string(),
  key: z.string().nullable().optional(),
  path: z.string(),
  size: z.number(),
  mimeType: z.string(),
  uploadSignedUrl: z.string().optional(),
  meta: MediaMetaSchema.nullable().optional(),
  createdAt: z.string().datetime(),
});

export const GameAssetDtoSchema = z.object({
  id: z.string(),
  gameId: z.string(),
  mediaId: z.string(),
  order: z.number(),

  media: MediaDtoSchema,
}).merge(createUpdateZodSchema);

export type MediaDto = z.infer<typeof MediaDtoSchema>;
export type MediaMetaDto = z.infer<typeof MediaMetaSchema>;
export type GameAssetDto = z.infer<typeof GameAssetDtoSchema>;
